import BaseTemplate from '@/kyna/layouts/BaseTemplate';
import CareersMenuView from '@/kyna/view/_public/CareersMenuView';

export default function Careers() {
  return (
    <BaseTemplate title="Careers" body={<CareersMenuView />} />
  )
}
